export default {
  state: {
    title: 'Tila',
    visible: 'Pöytätilaus näkyvissä',
    on: 'Pöytätilaus',
  },
  notes: {
    hidden: {
      title: 'Pöytätilaus on piilotettu',
      description:
        'Toiminto on käytössä, mutta kauppasi ei näytä sitä, joten kaikki pöytätilaukset hylätään. Ota käyttöön ”Pöytätilaus näkyvissä” näyttääksesi sen.',
      link: 'Siirry kytkimeen',
    },
    off: {
      title: 'Vieraat eivät voi nyt tilata pöytään',
      description:
        'Aloita kytkemällä molemmat kytkimet päälle. Siihen asti pöydän QR-koodi avaa kauppasi Noudolla ja Kuljetuksella.',
    },
    no_active_table: {
      title: 'Vieraat eivät voi vielä tilata pöytään',
      description: 'Lisää alla pöytä ja kytke se päälle.',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
};
